import { renderPdfPagesAsPng } from "../../components/document-processing/pdfPreview";
import { isPdfFile } from "../../components/document-processing/pdfBatchExtraction";

export const runFigureJob = async ({ file, mode, quality = "standard", start, poll, isCurrent, onProgress = () => {} }) => {
  const bounded = (promise) => {
    let timer;
    return Promise.race([promise, new Promise((_, reject) => { timer = setTimeout(() => reject(new Error("服務回應逾時。")), 90000); })]).finally(() => clearTimeout(timer));
  };
  const response = await bounded(start(file, mode, quality));
  if (!response.success || !response.job?.id) throw new Error(response.error || "無法建立附圖工作。");
  let job = response.job; const deadline = Date.now() + 15 * 60 * 1000;
  while (["queued", "running"].includes(job.status)) {
    if (!isCurrent()) return null;
    if (Date.now() > deadline) throw new Error("附圖工作等待逾時，可稍後重試。");
    onProgress(job.status === "queued" ? "排隊中" : "處理中");
    await new Promise((resolve) => setTimeout(resolve, 1500));
    if (!isCurrent()) return null;
    const next = await bounded(poll(job.id));
    if (!next.success || !next.job) throw new Error(next.error || "工作查詢失敗。");
    job = next.job;
  }
  if (!isCurrent()) return null;
  if (job.status !== "success") throw new Error(job.error || "附圖工作失敗。");
  return job;
};

export const loadFigurePage = async (file, page) => {
  const blob = isPdfFile(file) ? (await renderPdfPagesAsPng(file, [{ id: "batch", pageIndex: page - 1 }]))[0].blob : file;
  const url = URL.createObjectURL(blob);
  try {
    return await new Promise((resolve, reject) => { const image = new Image(); image.onload = () => resolve(image); image.onerror = () => reject(new Error("原圖無法讀取。")); image.src = url; });
  } finally { URL.revokeObjectURL(url); }
};

export const cropFigureImage = async (image, bbox) => {
  const [x, y, w, h] = bbox;
  const width = Math.round(image.naturalWidth * w); const height = Math.round(image.naturalHeight * h);
  if (width < 10 || height < 10) throw new Error("附圖範圍太小。");
  const scale = Math.min(1, 3000 / Math.max(width, height)); const canvas = document.createElement("canvas");
  canvas.width = Math.round(width * scale); canvas.height = Math.round(height * scale);
  canvas.getContext("2d").drawImage(image, image.naturalWidth * x, image.naturalHeight * y, width, height, 0, 0, canvas.width, canvas.height);
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
  if (!blob) throw new Error("附圖裁切失敗。");
  return { file: new File([blob], "handout-figure.png", { type: "image/png" }), preview: canvas.toDataURL("image/png") };
};

export const processFigurePool = async (items, process, isCurrent, concurrency = 4) => {
  let next = 0;
  await Promise.all(Array.from({ length: Math.min(concurrency, items.length) }, async () => {
    while (isCurrent() && next < items.length) {
      const index = next++; await process(items[index], index);
    }
  }));
};

export const figurePreviewWithTimeout = async (preview, code) => {
  let timer;
  try { return await Promise.race([preview(code), new Promise((_, reject) => { timer = setTimeout(() => reject(new Error("預覽逾時，程式碼已保留。")), 90000); })]); }
  finally { clearTimeout(timer); }
};
